/**
 * Single source of truth for Team blueprint text and list caps.
 *
 * Three layers share these numbers: the backend generation schemas
 * (prospects/companyProfile.ts, prospects/teamPlanner.ts), the owner-edit
 * schema (onboarding/teamBlueprintValidation.ts), and the frontend review
 * form (pages/companyTeamOnboarding/model.ts). The invariant that keeps an
 * UNEDITED server-generated plan saveable is: every edit-side cap must be
 * >= the corresponding generation-side cap. Using one constant per field
 * makes that hold by construction.
 */
export const TEAM_BLUEPRINT_LIMITS = {
    // Company profile text fields.
    legalOrBrandName: 180,
    oneLiner: 500,
    whatTheyDo: 2_000,
    whoTheyServe: 1_000,
    industry: 160,
    stageOrSize: 500,
    businessModel: 500,
    product: 240,
    customerSegment: 240,
    operatingPriority: 320,
    maxProducts: 12,
    maxCustomerSegments: 12,
    maxOperatingPriorities: 8,
    // Team candidate fields.
    teamName: 160,
    roleTitle: 160,
    responsibility: 320,
    maxResponsibilities: 12,
    numberLabel: 160,
    // Generation turns each recurring duty into a Playbook rule and appends a
    // trailing period, so the stored rule cap must exceed the duty cap.
    recurringDuty: 320,
    playbookRule: 340,
    maxRecurringDuties: 8,
    // Role priors seed up to 3 rules ahead of the recurring duties, so the
    // edit-side rule count must stay above maxRecurringDuties + prior rules.
    maxPlaybookRules: 12,
    connectionId: 100,
    timezone: 100,
    sourceUrl: 2_000,
    // Room shape.
    maxTeams: 6,
    maxEnabledTeams: 5,
};
//# sourceMappingURL=teamBlueprintLimits.js.map